'use client';
import React, { useEffect, useRef } from 'react';
import styles from './modal.module.scss';
import { ModalHeader } from './components/modal-header';
//import classes from "clsx";

interface IModal {
  modalBody: React.ReactNode;
  isOpen: boolean;
  toggleModal(): void;
  headerTitle?: string;
  modalFooter?: React.ReactNode;
  className?: string;
}

export const Modal: React.FC<IModal> = ({
  modalBody,
  modalFooter,
  isOpen,
  headerTitle,
  toggleModal,
  className,
}) => {
  const modalRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';

      const handleClickOutside = (event: MouseEvent) => {
        if (
          modalRef.current &&
          !modalRef.current.contains(event.target as Node)
        ) {
          toggleModal();
        }
      };

      const handleEscKey = (event: KeyboardEvent) => {
        if (event.key === 'Escape') {
          toggleModal();
        }
      };

      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('keydown', handleEscKey);

      return () => {
        document.body.style.overflow = '';
        document.removeEventListener('mousedown', handleClickOutside);
        document.removeEventListener('keydown', handleEscKey);
      };
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen, toggleModal]);

  useEffect(() => {
    if (isOpen) {
      document.getElementById('modalHeaderTitle')?.focus();
      const contentElement = modalRef.current?.querySelector(
        `.${styles.content}`,
      ) as HTMLElement | null;
      contentElement?.focus();
    }
  }, [isOpen]);
  return (
    isOpen && (
      <>
        <div className={styles.modal}>
          <div
            className={styles.dialog + ' ' + className} //classes(styles.dialog, className)
            ref={modalRef}
            role="dialog"
            aria-modal="true"
          >
            <div className={styles.content} tabIndex={-1}>
              {headerTitle && (
                <ModalHeader
                  headerTitle={headerTitle}
                  toggleModal={toggleModal}
                />
              )}
              {modalBody}
              {modalFooter}
            </div>
          </div>
        </div>
        <div className={styles.backdrop} />
      </>
    )
  );
};
